'use client';
// Cupos restantes de la campaña «primeros 100 de la app» (API pública, cache 60 s).
import { useEffect, useState } from 'react';

export default function Cupos() {
  const [restantes, setRestantes] = useState(null);
  useEffect(() => {
    let vivo = true;
    fetch('/api/campaigns/app-100')
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => { if (vivo && typeof s?.remaining === 'number') setRestantes(s.remaining); })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);
  return restantes ?? '—';
}
